import { useTranslation } from '@gimlite/common';
import { useStoreUIV1, Wizard } from '@gimlite/ui-v1';
import { observer } from 'mobx-react-lite';
import { portal } from '../../config';
import { ActionStep } from './steps/action/action.step';

export type ChoiceCreateContractWizardContext = {
  parkingId: string | null;
  actions: {
    createNewSingleContract: boolean;
    createNewMasterPoolContract: boolean;
    createNewSubPoolContract: boolean;
    addOneMotoristToAnExistingPoolContract: boolean;
    addSeveralMotoristsToAnExistingPoolContract: boolean;
  };
  mode: typeof portal;
};

export const ChoiceCreateContractWizard = observer(() => {
  const { t } = useTranslation();
  const { WizardStore } = useStoreUIV1();

  const { parkingId, actions, mode } = WizardStore?.selected?.store;

  return (
    <Wizard<ChoiceCreateContractWizardContext>
      config={{
        title: t(`theDifferentActionsLinkedToContracts`),
        withNavigation: false,
      }}
      data={{
        defaultContext: { parkingId, actions, mode },
      }}
      handleEvent={{
        done: async (data) => {
          console.log('done', { data });
        },
        clear: () => {
          console.log('CLEAR');
        },
        close: () => {
          WizardStore.clear();
        },
      }}
    >
      <Wizard.Item
        config={{
          title: t('action'),
          component: ActionStep,
        }}
      />
    </Wizard>
  );
});
